import classNames from "classnames";
import { isEmpty } from "lodash";
import React from 'react';

const Checkbox = ({
    id,
    name,
    label,
    value,
    handleChange,
    className = "",
    checked,
    formValidate = {},
    leftLabel = false,
    attrs = {},
    labelOnClick = null,
}) => {
    const validate = isEmpty(formValidate) ? {
        onChange: (e) => handleChange(e),
        name
    } : formValidate;

    const attr = {
        ...attrs,
        ...validate
    };

    const labelClasses = classNames(
        'text-sm leading-normal text-black font-light relative cursor-pointer inline-flex items-center h-6',
        'before:content-[""] before:border before:rounded before:h-6 before:w-6 before:absolute',
        'after:content-[""] after:absolute after:top-0.75 after:px-0.5 after:py-1.5',
        {
            'pr-8 before:right-0 after:right-2.5': leftLabel,
            'pl-8 before:left-0 after:left-2.5': !leftLabel,
        },
        {
            'checked before:bg-primary before:border-primary after:flex after:border-white after:border-b-2 after:border-r-2 after:rotate-45': checked,
            'before:border-mischka before:bg-white': !checked,
        },
        {
            [className]: className !== '',
        },
    );

    return (
        <>
            <input
                type="checkbox"
                id={id ? id : value}
                value={value}
                checked={checked}
                className={`hidden cursor-pointer`}
                {...attr}
            />
            <label className={labelClasses} onClick={labelOnClick}
                htmlFor={id ? id : value}>{label}</label>
        </>
    );
};

export default Checkbox;
